import Services from '@/utils/services'

const state = {
    username: '',
    fullName: '',
    unitId: null,
    privileges: [],
    isAuthenticated: false,
};
window.svc = Services;
const actions = {
    loadIdentity(context) {
        //return new Promise((resolve, reject) => {
        //    mgr.getUser().then(user => {
        //        if (user != null) {
        //            context.commit("setIdentity", user.profile);
        //            context.dispatch('initializeSettings').then(() => {
        //                resolve(true);
        //            }).catch(() => {
        //                resolve(false);
        //            });
        //        } else {
        //            resolve(false);
        //        }
        //    }).catch(() => {
        //        resolve(false)
        //    });
        //});
        var accessToken = Services.getAccessToken();
        if (accessToken) {
            context.commit("setIdentity", accessToken);
            context.dispatch('initializeSettings');
        }
    },
    authenticate(context, { username, password }) {
        return Services.login(username, password).done(function (accessToken) {
            context.commit("setIdentity", accessToken);
            context.dispatch('initializeSettings');
        });
    },
    checkIdentity(context, identity) {
        if (identity) {
            if (new Date(identity['expires']) <= new Date() && identity.refresh_token) {
                Services.refreshToken(identity.refresh_token).done(function (accessToken) {
                    context.commit("setIdentity", accessToken);
                });
            } else {
                context.commit("setIdentity", identity);
            }
        }
    },
    deauthenticate(context) {
        Services.logout();
        context.commit('removeIdentity');
    }
};

// mutations
const mutations = {
    setIdentity(state, identity) {
        state.username = identity.username;
        state.fullName = identity.fullName;
        state.privileges = identity.privileges;
        state.isAuthenticated = true;
    },
    removeIdentity(state) {
        state.username = '';
        state.fullName = '';
        state.privileges = [];
        state.isAuthenticated = false;
    }
};

export default {
    state,
    actions,
    mutations
};
